import { ILog } from '../../../global/types';
import { AccountDatasource } from '../../datasources/account_datasource';
import { ICommand } from 'core-ts-types';
import { Validation } from '../../components/password_validation_popover/password_validation_popover';
import { IServerResponse } from '../../../global/interfaces/server_response';
import { ErrorsDict, IFormErrorService } from '../../../global/services/form_error_service/form_error_service';

export interface IProfile extends Record<string, string> {}

export class UpdateProfileController {
  private update_profile: ng.IFormController;
  private passwordValidations: Validation;
  private profile: IProfile;
  private isNewPasswordChanged = false;
  private isNewPasswordValid = false;
  private showLoginAttemptFailureMessage = false;
  private errors: ErrorsDict;

  constructor(
    private log: ILog,
    private ngAccountDatasource: AccountDatasource,
    private $timeout: ng.ITimeoutService,
    private validatePasswordCommand: ICommand,
    private updateProfileCommand: ICommand,
    private phxPasswordValidationPopoverDelegate: any,
    private formErrorService: IFormErrorService,
    private $element: ng.IAugmentedJQuery
  ) {
    const account = _.clone(this.ngAccountDatasource.read());

    this.profile = {
      email: account.email,
      first_name: account.first_name,
      last_name: account.last_name
    };
    this.onPasswordChange();
  }

  // TODO move to service? what is best way to make this DRY?
  onPasswordChange(): void {
    this.$timeout(() => {
      this.isNewPasswordValid = false;
      this.validatePasswordCommand(this.profile['new_password'] || '').then((res) => {
        this.passwordValidations = res;
        this.isNewPasswordValid = _.all(this.passwordValidations);
      });
    });
  }

  resetPasswordFields() {
    const passwordFields = ['up_new_password-input', 'up_password_current'];
    passwordFields.forEach((fieldName) => {
      const passwordField = this.$element.find(`#${fieldName}`)[0];
      if (!passwordField) {
        return;
      }
      passwordField.setAttribute('value', '');
    });
  }

  submitForm(): void {
    this.showLoginAttemptFailureMessage = false;
    this.errors = {};

    let fieldsToSend: IProfile = {
      first_name: this.profile['first_name'],
      last_name: this.profile['last_name'],
      password: this.profile['password']
    };

    if (!_.isEmpty(this.profile['new_password'])) {
      fieldsToSend['new_password'] = this.profile['new_password'];
    }

    this.updateProfileCommand(fieldsToSend)
      .then(() => {
        this.log.user.success({
          content: 'Your changes have been saved',
          timeout: 10000,
          dismissOnTimeout: true,
          dismissButton: true
        });
        this.resetPasswordFields();
        this.$timeout(() => {
          // TODO move to service to make it DRY
          this.validatePasswordCommand('').then((res) => {
            this.passwordValidations = res;
            this.isNewPasswordValid = _.all(this.passwordValidations);
          });
        });
      })
      .catch((res: ng.IHttpPromiseCallbackArg<IServerResponse>) => {
        this.showLoginAttemptFailureMessage = true;
        this.errors = this.formErrorService(res.data!.error);
      });
  }
}

angular.module('capability-ng-user-app').controller('ngUpdateProfileController', UpdateProfileController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/update_profile/update_profile.ts